/* eslint-disable prettier/prettier */
export const contractRouterAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    stateMutability: 'payable',
    type: 'fallback',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'programId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
      {
        internalType: 'uint8',
        name: 'level',
        type: 'uint8',
      },
      {
        internalType: 'uint256',
        name: 'minPollySwapped',
        type: 'uint256',
      },
    ],
    name: '_activateIncomeLevel',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
      {
        internalType: 'uint8[]',
        name: 'x2Levels',
        type: 'uint8[]',
      },
      {
        internalType: 'uint8[]',
        name: 'x4Levels',
        type: 'uint8[]',
      },
      {
        internalType: 'uint256',
        name: 'rate',
        type: 'uint256',
      },
    ],
    name: 'buyLevelsX2X4',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
      {
        internalType: 'uint8[]',
        name: 'x2Levels',
        type: 'uint8[]',
      },
      {
        internalType: 'uint8[]',
        name: 'x4Levels',
        type: 'uint8[]',
      },
      {
        internalType: 'uint256',
        name: 'rate',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'activateIncome',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'minPollySwappedX2',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minPollySwappedX4',
        type: 'uint256',
      },
    ],
    name: 'buyLevelsX2X4V2',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'claimNfts',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'developmentWallet',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'energyNft',
    outputs: [
      {
        internalType: 'contract IEnergyNft',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'energyPool',
    outputs: [
      {
        internalType: 'contract IEnergyPool',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getIncomeRouter',
    outputs: [
      {
        internalType: 'contract IIncomeRouter',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'level',
        type: 'uint256',
      },
    ],
    name: 'getLevelFee',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
    ],
    name: 'getUserAvailableNfts',
    outputs: [
      {
        internalType: 'uint256[30]',
        name: 'res',
        type: 'uint256[30]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
      {
        internalType: 'uint8',
        name: 'level',
        type: 'uint8',
      },
      {
        internalType: 'bool',
        name: 'isX4',
        type: 'bool',
      },
    ],
    name: 'handleReinvest',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract IPolly',
        name: '_polly',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_pollyStaking',
        type: 'address',
      },
      {
        internalType: 'contract IEnergyPool',
        name: '_energyPool',
        type: 'address',
      },
      {
        internalType: 'contract IX2X4',
        name: '_x2x4',
        type: 'address',
      },
      {
        internalType: 'contract IEnergyNft',
        name: '_energyNft',
        type: 'address',
      },
    ],
    name: 'init',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lastLevel',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'polly',
    outputs: [
      {
        internalType: 'contract IPolly',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pollyStaking',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'referrerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'refNumber',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'x2Levels',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'x4Levels',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'rate',
        type: 'uint256',
      },
    ],
    name: 'registrationX2X4',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'userAddress',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'referrerAddress',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'refNumber',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'x2Levels',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'x4Levels',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'rate',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'activateIncome',
        type: 'bool',
      },
      {
        internalType: 'uint256',
        name: 'minPollySwappedX2',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'minPollySwappedX4',
        type: 'uint256',
      },
    ],
    name: 'registrationX2X4V2',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'userEnergyNftAvailableToMint',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'x2x4',
    outputs: [
      {
        internalType: 'contract IX2X4',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    name: 'x2x4LevelPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];
